exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Scrollbar__scroll {\n  all: initial;\n  font-family: var(--font-family);\n}\n.DS__Scrollbar__scroll {\n  position: relative;\n  display: block;\n  width: 100%;\n  max-width: inherit;\n  max-height: 100%;\n  pointer-events: inherit;\n}\n", ""]);

// exports
exports.locals = {
	"scroll": "DS__Scrollbar__scroll"
};